import React, {
  useEffect,
  useReducer,
  createContext,
  useContext,
  useState,
} from "react";
import Cookies from "js-cookie";
import {
  getUser,
  userLogin,
  socialLogin,
  registerUserV3,
  userEmailLogin,
  userMobileLogin,
  newRegisterUserV3,
  getIpDetials,
} from "../api/api";
import { getFirebaseToken } from "../firebase/Firebase";
import { toast } from "react-toastify";

export const AuthContext = createContext(null);
export const useAuthContext = () => useContext(AuthContext);

function reducer(state, action) {
  switch (action.type) {
    case "LOADING":
      return { ...state, isLoading: true };
    case "LOGIN":
      return { ...state, user: action.payload, isLoading: false };

    case "LOGOUT":
      return { ...state, user: null, isLoading: false };

    case "ERROR":
      return { ...state, user: null, isLoading: false };
    case "PLAY_INSTRUCTION_AUDIO":
      return { ...state, playInstructionAudio: action.payload };

    default:
      throw new Error();
  }
}

// auth provider
export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, {
    user: null,
    playInstructionAudio: true,
    isLoading: true,
  });

  const [userDetails, setUserDetails] = useState();

  const _handleOnLoad = async () => {
    const userToken = await Cookies.get("userToken");
    if (!userToken) {
      dispatch({ type: "LOGOUT" });
      return () => {};
    }

    const userData = await Cookies.get("userData");
    try {
      const playInstructionAudio = Cookies.get("playAudio");
      dispatch({
        type: "PLAY_INSTRUCTION_AUDIO",
        payload: playInstructionAudio == "true" ? true : false,
      });
      if (userData) dispatch({ type: "LOGIN", payload: JSON.parse(userData) });
      else await updateUser();
    } catch (error) {
      await updateUser();
    }
  };

  // useEffect(() => {
  //   _handleOnLoad();
  // }, []);

  const login = async ({
    email = null,
    password = null,
    mobile = null,
    otp = null,
    hash = null,
  } = {}) => {
    dispatch({ type: "LOADING" });
    let response;
    if (email) {
      response = await userEmailLogin(email, password);
    } else if (mobile) {
      response = await userMobileLogin(mobile, otp, hash);
    }

    if (response && response.status == 200) {
      setUserDetails(response.token);
      //set token as cookie
      Cookies.set("userToken", response.token, {
        expires: 30,
        domain: "testing.getactyv.com",
      });
      Cookies.set("userToken", response.token, {
        expires: 30,
        domain: ".getactyv.com",
      });
      Cookies.set("userToken", response.token, { expires: 30 });
      Cookies.set("darkMode", true, {
        expires: 30,
        domain: ".getactyv.com",
      });
      Cookies.set("darkMode", true, { expires: 30 });
      const userData = await updateUser();
      // getFirebaseToken();
      return userData;
    } else if (response) {
      toast(response.message, { type: "error" });
      dispatch({ type: "ERROR" });
      return null;
    } else {
      toast("Some Error Occured", { type: "error" });
      dispatch({ type: "ERROR" });
      return null;
    }
  };

  useEffect(() => {
    // login();
    _handleOnLoad();
  }, [userDetails]);

  const logout = () => {
    Cookies.remove("userToken", { domain: ".getactyv.com" });
    Cookies.remove("userData", { domain: ".getactyv.com" });
    Cookies.remove("userToken");
    Cookies.remove("userData");
    Cookies.remove("darkMode");
    Cookies.remove("darkMode", { domain: ".getactyv.com" });
    Cookies.remove("dontShowInstruction");
    dispatch({ type: "LOGOUT" });
  };

  const register = async (json) => {
    try {
      const ipDetails = await getIpDetials();
      if (ipDetails) {
        json.ip = ipDetails.ip;
        json.registerCity = ipDetails.city;
        json.registerRegionName = ipDetails.region;
        json.registerCountry = ipDetails.country;
        json.timezone = ipDetails.timezone;
        json.in_eu = ipDetails.in_eu;
        json.utc_offset = ipDetails.ust_offset;
        json.country_calling_code = ipDetails.country_calling_code;
      }
    } catch (error) {}
    const response = await newRegisterUserV3(json);
    if (response && response.success) {
      //set token as cookie
      setUserDetails(response.token);
      Cookies.set("userToken", response.token, {
        expires: 30,
        domain: ".getactyv.com",
      });
      Cookies.set("userToken", response.token, { expires: 30 });
      Cookies.set("darkMode", true, {
        expires: 30,
        domain: ".getactyv.com",
      });
      Cookies.set("darkMode", true, { expires: 30 });
      await updateUser();
      // getFirebaseToken();
      return response;
    } else {
      return response;
    }
  };

  async function updateUser() {
    dispatch({ type: "LOADING" });

    const userData = await getUser();

    if (!userData || userData == "Unauthorized") {
      dispatch({ type: "LOGOUT" });
      return;
    }
    Cookies.set("userData", JSON.stringify(userData), {
      expires: 30,
      domain: ".getactyv.com",
    });
    Cookies.set("userData", JSON.stringify(userData), { expires: 30 });
    dispatch({ type: "LOGIN", payload: userData });
    getFirebaseToken();
    return userData;
  }

  async function socialMediaLogin({ type, id, email }) {
    dispatch({ type: "LOADING" });
    const response = await socialLogin(type, id, email);

    if (response && response.success) {
      //set token as cookie
      Cookies.set("userToken", response.token, {
        expires: 30,
        domain: ".getactyv.com",
      });
      Cookies.set("userToken", response.token, { expires: 30 });
      Cookies.set("darkMode", true, {
        expires: 30,
        domain: ".getactyv.com",
      });
      Cookies.set("darkMode", true, { expires: 30 });
      const userData = await updateUser();
      return userData;
    } else {
      dispatch({ type: "ERROR" });
      return null;
    }
  }

  const updatePlayInstructionAudio = (playAudio) => {
    dispatch({ type: "PLAY_INSTRUCTION_AUDIO", payload: playAudio });
  };

  return (
    <AuthContext.Provider
      value={{
        state,
        login,
        logout,
        register,
        updateUser,
        socialMediaLogin,
        updatePlayInstructionAudio,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
